import React, { useEffect, useState } from "react";
import { useResizeDetector } from "react-resize-detector";
import { Container, Row, Col } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

//import "../css/SocialMedia.css";
import "../App.css";

export default function SocialMedia() {
  const imgCDNURL = process.env.REACT_APP_SUNWESTEXPO_CDN_URL;

  const { width, ref } = useResizeDetector();

  let device;
  if (width < 768) {
    device = "mobile";
  }  else if (width < 992) {
    device = "tablet";
} 
 else {
    device ="desktop";
}
  const responsive = {
    tablet: {
      breakpoint: { max: 991, min: 768 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      items: 1,
    },
    desktop: {
        breakpoint: { max: 2000, min: 992 },
        items: 3,
    }
  };

  return (
   
    <div className="sm-bg">
    
    <Container >
      
      <Row>
      
        <Col lg={12} >
            <div>
        <h2 className="text-center pb-4 pt-2 social"> Social Media Posts </h2>
        </div>
          <Carousel
            autoPlay
            interval="7000"
            transitionTime="3000"
            infiniteLoop
            responsive={responsive}
            showIndicators={true}
            minimumTouchDrag={80}
            slidesToSlide={1}
            //partialVisibile={true}
           // showArrows={false}
           showDots={true}
           
               className="text-center"

            
          >
            <div>
              <a
                target="_blank"
                rel="noreferrer noopener"
                className="btnEventVideo"
                href="https://www.linkedin.com/posts/sun-west-mortgage-company_sunwestmortgage-wegetyou-morgan-activity-6975131309803278336-0-ZH?utm_source=share&utm_medium=member_desktop"
                title="Finance On Demand video"
              >
                <img
                  src={imgCDNURL + "social-media/1.webp"}
                  alt=""
                  className="post"
                />
              </a>
            </div>

            <div>
              <a
                target="_blank"
                rel="noreferrer noopener"
                className="btnEventVideo"
                href="https://www.linkedin.com/posts/aditya-pandey-16973247_sunwestmortgage-mytruehome-usemorgan-activity-6975158362862706688-FOTR?utm_source=share&utm_medium=member_desktop"
                title="Finance On Demand video"
              >
                <img
                  src={imgCDNURL + "social-media/2.webp"}
                  alt=""
                  className="post"
                />
              </a>
            </div>
            <div>
              <a
                target="_blank"
                rel="noreferrer noopener"
                className="btnEventVideo"
                href="https://www.linkedin.com/posts/andrewojeisekhoba_morgan-activity-6973755161353617408--MgF?utm_source=share&utm_medium=member_desktop"
                title="Finance On Demand video"
              >
                <img
                  src={imgCDNURL + "social-media/3.webp"}
                  alt=""
                  className="post"
                />
              </a>
            </div>
          </Carousel>
        </Col>
        </Row>
        </Container>
        </div>
           
  );
}
